import { render } from "./keyinvestment.vue?vue&type=template&id=a11e0aea&scoped=true"
import script from "./keyinvestment.vue?vue&type=script&lang=js"
export * from "./keyinvestment.vue?vue&type=script&lang=js"

import "./keyinvestment.vue?vue&type=style&index=0&id=a11e0aea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a11e0aea"

export default script